import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../QueryKey'
import {getExchanges} from '../../apis/exchanges/exchange'

const useQueryExchanges = (enabled?: boolean) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.exchanges.exchange(),
        queryFn: async () => {
            const {data} = await getExchanges()
            return data
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        staleTime: 120 * 1000,
        cacheTime: 120 * 1000,
    })

    return {data, refresh: refetch, isLoading}
}

export default useQueryExchanges
